export const VERDICT_LABELS = {
  aligned: "Looks aligned",
  discuss_first: "Discuss before merging",
  changes_recommended: "Changes recommended",
  insufficient_context: "Needs more product context",
  failed: "Review failed",
};

export const REVIEW_TYPE_LABELS = {
  decision: "Decision Review",
  acceptance: "Acceptance Review",
};

export const CURRENCY_LABELS = {
  current: "Current",
  stale: "Stale",
};

export const FILTERS = [
  { id: "current", label: "Recent" },
  { id: "running", label: "Running" },
  { id: "completed", label: "Completed" },
  { id: "failed", label: "Failed" },
  { id: "historical", label: "Historical" },
];

export const TYPE_FILTERS = [
  { id: "all", label: "All types" },
  { id: "decision", label: "Decision Review" },
  { id: "acceptance", label: "Acceptance Review" },
];
